/**
 * @desc 更新
 */
import { PricingMethodForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdatePricingMethodParameter = PricingMethodForm

const method = 'PUT'
const url = '/trade/pricingMethod'

export const updatePricingMethodApi = (
  data?: UpdatePricingMethodParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

updatePricingMethodApi.method = method
updatePricingMethodApi.url = url
